export default {"src":"/_next/static/media/icon2.03fc1f24.svg","height":1080,"width":1080,"blurWidth":0,"blurHeight":0};